import { MenuItem } from '@mui/material'
import { ReassignTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/ReassignTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ReassignTaskDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const ReassignTaskDropdownOption: FC<ReassignTaskDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(ReassignTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_reassign_task_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_reassign_task" defaultMessage="Reassign to..." />
        </MenuItem>
    )
}
